import { IconButton } from '@radix-ui/themes';

export default IconButton;
